import { SearchFilters } from '../maps-search/schemas'

export class SeenCampsites {
  private storageKey = 'seenMapCampsites'
  private key: string
  private slugs: Set<string>

  constructor(searchFilters: SearchFilters) {
    this.key = this.getKey(searchFilters)
    this.resetStorage()
    this.slugs = this.getSlugsFromStorage()
  }

  get(): string[] {
    return Array.from(this.slugs)
  }

  private getKey(searchFilters: SearchFilters) {
    const { dates, categoryIds } = searchFilters
    const arrive = dates ? dates.arrive : ''
    const depart = dates ? dates.depart : ''
    const categories = categoryIds ? categoryIds.join(',') : ''
    return `${arrive}|${depart}|${categories}`
  }

  private resetStorage() {
    const data = JSON.parse(localStorage.getItem(this.storageKey) || 'null')
    if (data === null || data.key !== this.key) {
      localStorage.removeItem(this.storageKey)
      localStorage.setItem(
        this.storageKey,
        JSON.stringify(this.getEmptyStorageObj()),
      )
    }
  }

  private getEmptyStorageObj() {
    return { key: this.key, slugs: [] }
  }

  private getSlugsFromStorage(): Set<string> {
    const storageObj = JSON.parse(
      localStorage.getItem(this.storageKey) as string,
    )
    return new Set(storageObj.slugs)
  }

  add(slug: string) {
    this.slugs.add(slug)
    const storageObj = JSON.parse(
      localStorage.getItem(this.storageKey) as string,
    )
    storageObj.slugs.push(slug)
    localStorage.setItem(this.storageKey, JSON.stringify(storageObj))
  }
}
